import React, { useState } from 'react';
import { Share2, Copy, Check } from 'lucide-react';
import { lunchMenu } from '../data/menuData';
import { locText, lunchUi, LUNCH_SITE_URL } from '../utils/lunchLocale';

const buildText = (menu, dayKey, lang) => {
  const ui = lunchUi(lang);
  const p = dayKey === 'weekend' ? lunchMenu.priceInfo.weekend : lunchMenu.priceInfo;
  const dishes = (menu.mains || []).map((m) => `• ${locText(m, 'name', lang)}`).join('\n');
  return `Ravintola Sunsari — ${locText(menu, 'day', lang)} (${menu.hours})\n\n${dishes}\n\n${ui.lunch} ${p.regular} · ${ui.students} ${p.student} · ${ui.pensioners} ${p.pensioner}\n\n${ui.seeWeek}: ${LUNCH_SITE_URL}`;
};

const btn = 'flex items-center justify-center gap-2 py-3 px-4 rounded-full text-sm font-semibold transition-colors shadow-sm';

export const ShareLunch = ({ menu, dayKey, lang }) => {
  const [copied, setCopied] = useState(false);
  const ui = lunchUi(lang);
  const text = buildText(menu, dayKey, lang);
  const canNative = typeof navigator !== 'undefined' && !!navigator.share;

  const copy = async () => {
    try { await navigator.clipboard.writeText(text); } catch { return; }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const native = async () => {
    try { await navigator.share({ title: 'Sunsari', text }); } catch { /* cancelled */ }
  };

  return (
    <div className="bg-white border border-[#D9D9D6] rounded-2xl p-4" data-testid="share-lunch">
      <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-bold text-[#6B705C] mb-3">
        <Share2 className="w-4 h-4 text-[#C97A2B]" /> {ui.share}
      </p>
      <div className={`grid gap-2 ${canNative ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-3'}`}>
        {canNative && (
          <button onClick={native} className={`${btn} bg-[#2F2F2F] text-white hover:bg-[#C97A2B]`} data-testid="share-native-btn">
            <Share2 className="w-4 h-4" /> {ui.shareNative}
          </button>
        )}
        <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer"
          className={`${btn} bg-[#25D366] text-white hover:bg-[#1DA851]`} data-testid="share-whatsapp-btn">
          WhatsApp
        </a>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(LUNCH_SITE_URL)}&quote=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer"
          className={`${btn} bg-[#1877F2] text-white hover:bg-[#0E5FCC]`} data-testid="share-facebook-btn">
          Facebook
        </a>
        <button onClick={copy} className={`${btn} bg-[#F5F3EF] border border-[#D9D9D6] text-[#2F2F2F] hover:border-[#C97A2B]`} data-testid="share-copy-btn">
          {copied ? <Check className="w-4 h-4 text-green-600" /> : <Copy className="w-4 h-4" />} {copied ? ui.copied : ui.copy}
        </button>
      </div>
    </div>
  );
};

export default ShareLunch;
